import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import { ReactComponent as BackArrow } from "../../../../Icons/BorderBackArrow.svg";
import { ReactComponent as DeleteSBIcon } from "../../../../Icons/DeleteSBIcon.svg";
import { ReactComponent as RefreshIcon } from "../../../../Icons/Refresh.svg";
import {
  PrimaryTypography,
  StyledSecondaryServiceTypography,
  SecondaryTypographyDefault,
  SecondaryTypography,
  StyledSecondaryTypography,
  TypographyDefault,
} from "../../../../Theme";
import {
  Stack,
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import AlertModal, {
  PostLoaderModal,
} from "../../../../CommonComponents/modal";
import axiosInstance from "../../../../Redux/AxiosInstance";
import { showToast } from "../../../../CommonComponents/Toaster";

const endAdornmentStyles = {
  position: "absolute",
  right: 0,
  top: "-20px",
  fontSize: "13px !important",
  "&>*": { fontSize: "13px !important", fontWeight: "400", color: "#9DA4AE" },
};

let leaveModalDatas = {
  label: "Are you sure you want to leave this section?",
  descriptionOne:
    "You have unfinished content to be filled. Filled information on this page will be lost if you leave the section.",
  buttonOne: {
    variant: "outlined",
    color: "#0E5E84",
    backgroundColor: "#FFFFFF",
    text: "Cancel",
  },
  buttonTwo: {
    variant: "contained",
    color: "#FFFFFF",
    backgroundColor: "#B42318",
    text: "Leave",
  },
};

export default function AddDocumentation() {
  const navigate = useNavigate();
  const { LanguageData } = useSelector((state) => state.Language);
  const [addblocks, setaddblocks] = useState({
    Details: true,
    Review_Information: false,
  });
  const blocks = [
    { status: addblocks.Details, tle: "Details" },
    { status: addblocks.Review_Information, tle: "Review Information" },
  ];
  const [questionData, setQuestionData] = useState({
    question: "",
    answer: "",
  });
  const [Questions, setQuestions] = useState([questionData]);
  const { propertyId } = useSelector((state) => state.PropertyDetails);

  const [errText, setErrText] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [leavemodal, setLeavemodal] = useState(false);
  const [deletemodal, setdeletemodal] = useState(false);
  const [postLoader, SetPostLoader] = useState(false);

  let deleteModalDatas = {
    label: "Confirm to delete question permanently",
    descriptionOne: `Please confirm that you wish to delete question ${
      deleteId + 1
    }. Upon deletion, the question ${
      deleteId + 1
    } will disappear from both dashboard and mobile app.`,
    buttonOne: {
      variant: "outlined",
      color: "#0E5E84",
      backgroundColor: "#FFFFFF",
      text: "Cancel",
    },
    buttonTwo: {
      variant: "contained",
      color: "#FFFFFF",
      backgroundColor: "#B42318",
      text: "Confirm",
    },
  };

  const handleQuestion = (e, id) => {
    const { name, value } = e.target;
    setQuestions((prev) => {
      const data = Questions.map((itm, index) => {
        if (index == id) {
          return { ...itm, [name]: value };
        }
        return itm;
      });
      return data;
    });
    setErrText((prev) => {
      const data = errText?.map((itm, index) => {
        if (index == id) {
          return { ...itm, [name]: false };
        }
        return itm;
      });
      return data;
    });
  };

  const AddQuestion = () => {
    setQuestions((prev) => [...prev, { question: "", answer: "" }]);
  };

  const deleteQuestion = () => {
    const data = Questions.filter((itm, index) => index != deleteId);
    setQuestions(data);
    closeModal();
  };

  useEffect(() => {
    if (Questions.length == 0) {
      navigate("/documentations");
    }
  }, [Questions]);

  const valid = () => {
    let isValid = true;
    setErrText((prev) => {
      const data = Questions.map((itm) => {
        const errs = { ...itm };
        for (const key in itm) {
          if (itm[key] == "") {
            Object.assign(errs, { [key]: true });
            isValid = false;
          } else if (itm[key] != "") {
            Object.assign(errs, { [key]: false });
          }
        }
        return errs;
      });
      return data;
    });
    return isValid;
  };

  const Continue = (nxtval) => {
    if (valid()) {
      if (nxtval == "Review Information") {
        setaddblocks({ Details: false, Review_Information: true });
      } else if (nxtval == "Details") {
        setaddblocks({ Details: true, Review_Information: false });
      }
    }
  };

  const closeModal = () => {
    setLeavemodal(false);
    setdeletemodal(false);
    setDeleteId(null);
  };

  const Details = () => {
    return (
      <>
        {Questions.map((itm, index) => {
          return (
            <Box
              backgroundColor="#FFFFFF"
              mb={4}
              sx={{ borderRadius: "8px", border: "1px solid #E5E7EB" }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                padding="16px"
                borderBottom="1px solid #E5E7EB"
              >
                <SecondaryTypography>
                  {LanguageData?.Question || "Question"} {index + 1}
                </SecondaryTypography>
                <DeleteSBIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setDeleteId(index);
                    setdeletemodal(true);
                  }}
                />
              </Stack>
              <Box sx={{ padding: "24px 10px 24px 10px" }}>
                <Box
                  sx={{
                    padding: "24px 16px 24px 16px",
                    borderRadius: "8px",
                    border: "1px solid #E5E7EB",
                  }}
                >
                  <SecondaryTypographyDefault>
                    {LanguageData?.Question || "Question"}
                  </SecondaryTypographyDefault>
                  <TextField
                    placeholder="Enter a question."
                    InputProps={{ disableUnderline: true }}
                    value={itm?.question}
                    name="question"
                    onChange={(e) => {
                      handleQuestion(e, index);
                    }}
                    sx={{
                      "& .MuiInputBase-root": {
                        color: errText[index]?.question ? "#912018" : "#111927",
                      },
                      backgroundColor: errText[index]?.question
                        ? "#FEE4E2"
                        : "",
                    }}
                  />

                  <SecondaryTypographyDefault mt={3}>
                    {LanguageData?.Answer || "Answer"}
                  </SecondaryTypographyDefault>
                  <TextField
                    placeholder="Enter answer to frequently asked question."
                    InputProps={{
                      disableUnderline: true,
                      endAdornment: (
                        <InputAdornment sx={endAdornmentStyles}>
                          {itm?.answer.length}/1000
                        </InputAdornment>
                      ),
                    }}
                    inputProps={{ maxLength: 1000 }}
                    value={itm?.answer}
                    name="answer"
                    onChange={(e) => {
                      handleQuestion(e, index);
                    }}
                    sx={{
                      minHeight: "88px",
                      "& .MuiInputBase-root": {
                        color: errText[index]?.answer ? "#912018" : "#111927",
                      },
                      backgroundColor: errText[index]?.answer ? "#FEE4E2" : "",
                    }}
                    multiline
                  />
                </Box>
                {Questions.length - 1 == index && (
                  <Box
                    display="flex"
                    justifyContent="center"
                    mt={4}
                    width="100%"
                  >
                    <Button
                      onClick={() => {
                        AddQuestion();
                      }}
                      sx={{
                        padding: "8px 14px 8px 14px",
                        height: "41px",
                        color: "#0E5E84",
                        border: "1px solid #E5E7EB",
                      }}
                    >
                      {LanguageData?.Add_More_FAQs || "Add More FAQs"}{" "}
                    </Button>
                  </Box>
                )}
              </Box>
            </Box>
          );
        })}

        <Box
          bgcolor="#FFFFFF"
          mt={5}
          sx={{
            borderTop: " 1px solid #F3F4F6",
            boxShadow: "0 0 3px 0 rgba(0 ,0 ,0 ,0.1)",
            borderRadius: "8px",
          }}
        >
          <Stack
            direction="row"
            py={2}
            px={2}
            justifyContent="end"
            alignItems="center"
            height="60px"
          >
            {/* <Stack direction="row">
              <RefreshIcon style={{ marginRight: "5px" }} />
              <StyledSecondaryTypography>
                Last Updated at {moment(new Date()).format("HH:mm A")}
              </StyledSecondaryTypography>
            </Stack> */}
            <Stack direction="column" justifyContent="end" alignItems="end">
              <Button
                onClick={() => Continue("Review Information")}
                sx={{
                  padding: "8px 14px 8px 14px",
                  height: "41px",
                  color: "#0E5E84",
                  backgroundColor: "#E7EFF3 !important",
                }}
              >
                {LanguageData?.Common_Continue || "Continue"}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </>
    );
  };

  const Review_Information = () => {
    const handleCreateQuestion = () => {
      axiosInstance
        .post(`${process.env.REACT_APP_API_URL}faq/property/${propertyId}`, {
          faq: Questions,
        })
        .then((res) => {
          if (res.data?.success) {
            navigate("/documentations");
            showToast(res?.data?.toast);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    };
    return (
      <>
        <Box
          backgroundColor="#FFFFFF"
          sx={{ borderRadius: "8px", border: "1px solid #E5E7EB" }}
        >
          {Questions.map((itm, index) => {
            return (
              <>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  px={2}
                  borderBottom="1px solid #E5E7EB"
                  sx={{ borderTop: index !== 0 ? "1px solid #E5E7EB" : "" }}
                  height="53px"
                >
                  <SecondaryTypography>
                    {LanguageData?.Question || "Question"} {index + 1}
                  </SecondaryTypography>
                  <DeleteSBIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setDeleteId(index);
                      setdeletemodal(true);
                    }}
                  />
                </Stack>
                <Grid container padding="12px 16px 20px 16px">
                  <Grid xs={12} sm={5.8}>
                    <StyledSecondaryServiceTypography>
                      {LanguageData?.Question || "Question"}
                    </StyledSecondaryServiceTypography>
                    <TypographyDefault>{itm?.question}</TypographyDefault>
                  </Grid>
                  <Grid xs={12} sm={5.8}>
                    <StyledSecondaryServiceTypography>
                      {LanguageData?.Answer || "Answer"}
                    </StyledSecondaryServiceTypography>
                    <TypographyDefault>{itm?.answer}</TypographyDefault>
                  </Grid>
                </Grid>
                {Questions.length - 1 == index && (
                  <Stack
                    direction="row"
                    px={2}
                    justifyContent="end"
                    alignItems="center"
                    height="81px"
                    borderTop="1px solid #E5E7EB"
                    borderRadius="0 0 8px 8px "
                  >
                    {/* <Stack direction="row">
                      <RefreshIcon style={{ marginRight: "5px" }} />
                      <StyledSecondaryTypography>
                        Last Updated at {moment(new Date()).format("HH:mm A")}
                      </StyledSecondaryTypography>
                    </Stack> */}
                    <Button
                      sx={{
                        padding: "8px 14px 8px 14px",
                        height: "41px",
                        color: "#0E5E84",
                        backgroundColor: "#E7EFF3 !important",
                      }}
                      onClick={() => {
                        handleCreateQuestion();
                        SetPostLoader(true);
                      }}
                    >
                      {LanguageData?.Common_CreateNow || "Create Now"}
                    </Button>
                  </Stack>
                )}{" "}
              </>
            );
          })}
        </Box>
      </>
    );
  };

  return (
    <>
      {postLoader && <PostLoaderModal />}
      {leavemodal && (
        <AlertModal
          modalDatas={leaveModalDatas}
          confirmFunction={() => navigate("/documentations")}
          closeFunction={closeModal}
        />
      )}
      {deletemodal && (
        <AlertModal
          modalDatas={deleteModalDatas}
          confirmFunction={deleteQuestion}
          closeFunction={closeModal}
        />
      )}

      <Box sx={{ backgroundColor: "#F3F4F6" }}>
        <Stack direction="row" justifyContent="space-between">
          <BackArrow
            style={{ cursor: "pointer" }}
            onClick={() => {
              setLeavemodal(true);
            }}
          />
        </Stack>
        <Stack
          my={4}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box>
            <PrimaryTypography mb={0.5}>
              {LanguageData?.Frequently_Asked_Questions ||
                "Frequently Asked Questions"}
            </PrimaryTypography>
            <StyledSecondaryTypography>
              {LanguageData?.add_doc ||
                "Add, edit or delete content regarding frequently asked questions."}
            </StyledSecondaryTypography>
          </Box>
        </Stack>
        <Grid container gap="1.5%" mb={5}>
          {blocks.map((itm) => {
            return (
              <Grid xs={5.91} onClick={() => Continue(itm.tle, "")}>
                <Box
                  component="div"
                  sx={{
                    borderTop: itm.status
                      ? "3px solid #0E4965"
                      : "3px solid #D2D6DB",
                    width: "100%",
                    color: itm.status ? "#0E4965" : "#9DA4AE",
                    cursor: "pointer",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "500",
                      fontSize: "12px",
                      padding: "10px 0 0 0",
                    }}
                  >
                    {itm.tle}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>

        {addblocks.Details && Details()}
        {addblocks.Review_Information && Review_Information()}
      </Box>
    </>
  );
}
